import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
const mapStatusToBg = {
    info: "blue.50",
    alert: "#e1c0c0"
};
const AlertWrapper = styled(Flex)`
  position: relative;

  font-size: ${themeGet("fontSizes.2")}px;
  line-height: 1.5;

  em {
    font-style: normal;
    font-weight: ${themeGet("fontWeights.bold")};
  }

  a {
    text-decoration: underline;
    color: ${themeGet("colors.blue.400")};
    font-weight: ${themeGet("fontWeights.bold")};
  }
`;
export const Alert = (props)=>{
    const { status , children  } = props;
    return /*#__PURE__*/ _jsx(AlertWrapper, {
        borderRadius: "12px",
        p: "16px",
        color: "black.87",
        bg: mapStatusToBg[status],
        children: children
    });
};
